import CheckList from "../../../../Atoms/CheckList";

interface Props {
  data: string | null;
}

export default function Highlights({ data }: Props) {
  return !!data && data.length > 0 ? (
    <div>
      <p
        style={{
          fontWeight: 700,
          fontSize: 22.5,
          marginBottom: 20,
        }}
      >
        What makes this tour unique
      </p>

      <div style={{ fontSize: 18 }}>
        <CheckList checkmarkColor="#e91e63" items={data.split("\n")} />
      </div>
    </div>
  ) : null;
}
